export const JIRA_INTEGRATION_INFO = 'expercJiraIntegrationInfo';
